import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  settings: {},
};

const { actions, reducer } = createSlice({
  name: "SETTINGS",
  initialState,
  reducers: {
    saveSettings: (state, action) => {
      state.settings = action.payload;
    },
  },
});

export const { saveSettings } = actions;

export default reducer;
